import React, { useEffect, useState } from "react";
import cx from "classnames";
import { bool, func, node, string } from "prop-types";
import useClickAway from "../../common/useClickAway.js";

const propTypes = {
  button: node.isRequired,
  children: node.isRequired,
  className: string,
  showClearButton: bool,
  onClearClick: func,
};

const ButtonDropdown = React.forwardRef((props, ref) => {
  const {
    button,
    children,
    className,
    onClearClick,
    showClearButton,
    ...otherProps
  } = props;

  const [isOpen, setOpen] = useState(false);

  const containerRef = useClickAway({ isOpen, setOpen });

  useEffect(() => {
    // exposing an imperative function to close the dropdown
    if (ref) {
      ref.current = {
        closeDropdown: () => setOpen(false),
      };
    }
  }, [ref]);

  return (
    <div
      className={cx("button-dropdown", className, {
        "button-dropdown--is-open": isOpen,
      })}
      ref={containerRef}
      {...otherProps}
    >
      <div className="select__button-holder">
        <button
          type="button"
          className="select__button"
          onClick={e => setOpen(!isOpen)}
        >
          {button}
        </button>
        {showClearButton && (
          <div className="select__clear-holder">
            <button
              className="coh-style-close"
              aria-label="clear selection"
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                onClearClick();
              }}
            ></button>
          </div>
        )}
      </div>
      <div
        className={cx("button-dropdown__dropdown", {
          "button-dropdown__dropdown--is-open": isOpen,
        })}
      >
        {children}
      </div>
    </div>
  );
});

ButtonDropdown.propTypes = propTypes;
export default ButtonDropdown;
